import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerSetWorkOrderChangeWorkRatioGql } from '../WorkOrderChangeQueries';

interface IUseUerSetWorkOrderChangeWorkRatio {
    workOrderChangePriceId: number;
    workOrderPriceId: number;
    onSuccess: () => void;
}

export const useUerSetWorkOrderChangeWorkRatio = (props: IUseUerSetWorkOrderChangeWorkRatio) => {
    const dispatch = useDispatch();

    const { workOrderPriceId, workOrderChangePriceId, onSuccess } = props;

    const requestId = useMemo(
        () => `uerSetWorkOrderChangeWorkRatio_${workOrderPriceId}_${workOrderChangePriceId}`,
        [workOrderChangePriceId, workOrderPriceId],
    );

    const [uerSetWorkOrderChangeWorkRatioReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerSetWorkOrderChangeWorkRatioReset(undefined);

        onSuccess();
    }, [onSuccess, uerSetWorkOrderChangeWorkRatioReset]);

    const [
        ,
        uerSetWorkOrderChangeWorkRatioStatus,
        ,
        uerSetWorkOrderChangeWorkRatioRequest,
        ,
        uerSetWorkOrderChangeWorkRatioAbortRequest,
    ] = useRequest({
        requestId,
        withEffect: false,
        query: uerSetWorkOrderChangeWorkRatioGql,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerSetWorkOrderChangeWorkRatioMakeRequest = useCallback(
        (ratio: number) => {
            const params = { workOrderPriceId, ratio, workOrderChangePriceId };

            if (uerSetWorkOrderChangeWorkRatioStatus === RequestStatus.FETCHING) {
                dispatch(uerSetWorkOrderChangeWorkRatioAbortRequest(undefined));
            }

            dispatch(uerSetWorkOrderChangeWorkRatioRequest(params));
        },
        [
            dispatch,
            uerSetWorkOrderChangeWorkRatioAbortRequest,
            uerSetWorkOrderChangeWorkRatioRequest,
            uerSetWorkOrderChangeWorkRatioStatus,
            workOrderChangePriceId,
            workOrderPriceId,
        ],
    );

    return { uerSetWorkOrderChangeWorkRatioMakeRequest, uerSetWorkOrderChangeWorkRatioStatus };
};
